// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3VpQD","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3x0ZF"};